import React from "react";
import { Link } from "react-scroll";

const About = () => {
  return (
    <>
      <div className="md:flex-row flex-col justify-evenly items-center my-12 font-semibold text-black w-3/4 mx-auto">
        <Link
          to="about"
          smooth
          duration={800}
          className="font-black text-4xl w-1/2 mx-auto"
        >
          Bio:
        </Link>
        <div className="flex flex-col justify-start items-start text-xl font-light my-4 py-10 text-center">
          <p className="p-4 ">
            <span className="font-bold text-4xl">"</span> Meet [Anmol Sen], a blockchain software developer who is just
            starting out in the industry. Anmol is a highly motivated and
            curious individual with a passion for decentralized technology.Anmol
            has a deep understanding of blockchain concepts, distributed
            systems, and smart contract development.
          </p>
          <p className="p-4">
          
            Anmol has also developed decentralized applications and understand
            the basics of cryptography and consensus mechanisms and have also
            learned Solidity and its Programming Framework and Libraries.
          </p>
          <p className="p-4">
            Anmol Sen from Bhilwara(Rajasthan),India is a B-Tech Graduate in
            Mechanical Engineering From A.C.I.T Jaipur(Rajasthan).
          </p>
          <p className="p-4">
            As a fresher, Anmol is excited to work with experienced blockchain
            developers and contribute to the growth of the blockchain ecosystem.
            In addition, Anmol is a team player, problem-solver, and always
            looking for ways to improve their skills and knowledge.Anmol is
            excited to be a part of a team and contribute to the growth and
            success of the project. <span className="font-bold text-4xl">"</span>
          </p>
          <hr className=" bg-black w-80 h-0.5 mx-auto my-6" />
        </div>
      </div>
    </>
  );
};

export default About;
